import { useAppContext } from '../../contexts/AppContext';
import { useEffect, useRef, useState } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsExporting from 'highcharts/modules/exporting';
import highchartsExportData from 'highcharts/modules/export-data';
import { Box } from '@mui/material';
import noDataToDisplay from 'highcharts/modules/no-data-to-display';
import { textLabels } from '../../constants';

highchartsExporting(Highcharts);
highchartsExportData(Highcharts);
noDataToDisplay(Highcharts);

type Props = {
  title: string;
  data: any;
  unit?: string;
  width?: string | number;
};

const chart = {
  chart: {
    type: 'pie',
    height: '350',
  },
  title: {
    text: '', // (' + Math.round(data?.average_soiling_ratio*1000)/1000 + ')',
    align: 'left',
  },
  legend: {
    enabled: true,
  },
  credits: {
    enabled: false,
  },
  exporting: {
    buttons: {
      contextButton: {
        menuItems: [
          'viewFullscreen',
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
          'separator',
          'downloadCSV',
          'downloadXLS',
        ],
      },
    },
  },
};

const PieChart = ({ title, data, unit = '%', width = undefined }: Props) => {
  const { isDarkMode } = useAppContext();
  const [chartOptions, setChartOptions] = useState<any>(chart);
  const chartComponent = useRef(null);

  useEffect(() => {
    if (data) {
      prepareHighcharts(prepareData());
    }
  }, [data]);

  const prepareData = () => {
    let timeseries_data: any[] = [];
    Object.keys(data?.distribution).forEach((key) => {
      timeseries_data.push({
        name: (textLabels as any)[key] || key,
        y: Math.abs(data.distribution[key]),
      });
    });
    return {
      name: 'Amount',
      data: timeseries_data,
    };
  };

  const prepareHighcharts = (highChartsData: any) => {
    const c = {
      chart: {
        width: width,
      },
      title: {
        text: title,
      },
      tooltip: {
        valueDecimals: 2,
        shared: true,
        valueSuffix: unit,
      },
      series: highChartsData,
    };
    setChartOptions(c);
  };

  return (
    <>
      <Box sx={{ /*display: 'flex',*/ justifyContent: 'center', pl: 1, pr: 1 }}>
        <HighchartsReact
          ref={chartComponent}
          containerProps={{ className: isDarkMode ? 'dark-chart' : '', style: { width: '100%' } }}
          highcharts={Highcharts}
          options={chartOptions}
        />
      </Box>
      {/* <pre>
        {JSON.stringify(data, null, 4)}
      </pre> */}
    </>
  );
};

export default PieChart;
